module.exports = __webpack_public_path__ + "img/twitter.b27c78f4.svg";